import React, { useEffect, useState } from 'react';
import { Box, Button, Typography, CircularProgress, Alert } from '@mui/material';
import { API_BASE_URL } from '../api';
import PublicBrandHeader from '../components/public/PublicBrandHeader';
import PublicBrandShell from '../components/public/PublicBrandShell';

export default function PublicReviewThanks() {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [config, setConfig] = useState(null);

  useEffect(() => {
    document.title = 'Thank you';
    let cancelled = false;
    fetch(`${API_BASE_URL}public/review/config`, { headers: { Accept: 'application/json' } })
      .then((res) => res.json())
      .then((json) => {
        if (!cancelled) setConfig(json.data || null);
      })
      .catch(() => {
        if (!cancelled) setError('Could not load page.');
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
      document.title = 'WorkWiseSoft';
    };
  }, []);

  const reviewUrl = config?.review_url || '';

  return (
    <PublicBrandShell embeddedBrand={config?.brand}>
      <Box sx={{ py: { xs: 3, md: 5 }, px: 2, maxWidth: 520, mx: 'auto' }}>
        <PublicBrandHeader subtitle="Thank you for your business" />
        {loading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', py: 4 }}>
            <CircularProgress />
          </Box>
        ) : null}
        {error ? <Alert severity="error">{error}</Alert> : null}
        {!loading && !error ? (
          <Box sx={{ textAlign: 'center' }}>
            <Typography variant="body1" sx={{ mb: 3 }}>
              We hope you were happy with our service. A short Google review helps us a lot.
            </Typography>
            {reviewUrl ? (
              <Button
                variant="contained"
                size="large"
                href={reviewUrl}
                target="_blank"
                rel="noopener noreferrer"
                sx={{ textTransform: 'none', fontWeight: 700 }}
              >
                Leave a Google review
              </Button>
            ) : (
              <Typography variant="body2" color="text.secondary">
                Review link is not configured yet. Please contact the office if you would like to share feedback.
              </Typography>
            )}
          </Box>
        ) : null}
      </Box>
    </PublicBrandShell>
  );
}
